"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Urls = void 0;
exports.Urls = {
    counter: {
        prefix: 'counter',
        walkIn: '/walkIn',
        addComment: '/addComment',
        backToAppointments: '/backToAppointments',
        backToQueue: '/backToQueue',
        bookAppointment: '/bookAppointment',
        updateAppointment: '/updateAppointment',
        confirmAppointment: '/confirmAppointment',
        finishProcessing: '/finishProcessing',
        inviteAppointment: '/inviteAppointment',
        queueInAppointment: '/queueInAppointment',
        rejectAppointment: '/rejectAppointment',
        removeComment: '/removeComment',
        updateFormData: '/updateFormData',
        getMessageCosts: '/getMessageCosts',
        pauseQueue: '/pauseQueue',
        removeFromProcessing: '/removeFromProcessing',
    },
    subscriptions: {
        prefix: 'subscriptions',
        cancelSubscription: '/cancelSubscription',
        createStripeCheckoutSession: '/createStripeCheckoutSession',
        onStripeUpdateSubscription: '/onStripeUpdateSubscription',
        onStripeCancelledSubscription: '/onStripeCancelledSubscription',
    },
    admin: {
        prefix: 'admin',
        copyPlace: '/copyPlace',
        createOrganisation: '/createOrganisation',
        updateOrganisation: '/updateOrganisation',
        declineInvitation: '/declineInvitation',
        acceptInvitation: '/acceptInvitation',
        removeOrgMember: '/removeOrgMember',
        withdrawInvitation: '/withdrawInvitation',
        inviteOrgMember: '/inviteOrgMember',
        updateOrgMember: '/updateOrgMember',
        resentInvite: '/resentInvite',
        migratePlace: '/migratePlace',
        migrateTickets: '/migrateTickets',
    },
    visitor: {
        prefix: 'visitor',
        walkIn: '/walkIn',
        bookAppointment: '/bookAppointment',
        cancelAppointment: '/cancelAppointment',
    },
    messaging: {
        prefix: 'messaging',
        onAppointmentEventSendNotifications: '/onAppointmentEventSendNotifications',
    },
};
//# sourceMappingURL=Urls.js.map